import Icon1 from "../icons/Icon";

export const Loading = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen bg-primary">
      <Icon1
        icon_name="hexagone-logement"
        size={70}
        fill="white"
        className="animate-spin"
      />
      <div className="mt-1 text-hx2 flex flex-row gap-2 items-center text-white">
        hexagone <span className="font-bold">logement</span>
      </div>
    </div>
  );
};
